<template>
  <div class="component-example">
    <slot />
  </div>
</template>

<script>
export default {
  props: {},
};
</script>

<style>
/*
* Style for nestable
*/
.nestable {
  position: relative;
}
.nestable-rtl {
  direction: rtl;
}
.nestable .nestable-list {
  margin: 0;
  padding: 0 0 0 40px;
  list-style-type: none;
}
.nestable-rtl .nestable-list {
  padding: 0 40px 0 0;
}
.nestable > .nestable-list {
  padding: 0;
}
.nestable-item,
.nestable-item-copy {
  margin: 10px 0 0;
}
.nestable-item:first-child,
.nestable-item-copy:first-child {
  margin-top: 0;
}
.nestable-item .nestable-list,
.nestable-item-copy .nestable-list {
  margin-top: 10px;
}
.nestable-item {
  position: relative;
}
.nestable-item.is-dragging .nestable-list {
  pointer-events: none;
}
.nestable-item.is-dragging * {
  opacity: 0;
  filter: alpha(opacity=0);
}
.nestable-item.is-dragging:before {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(106, 127, 233, 0.274);
  border: 1px dashed rgb(73, 100, 241);
  -webkit-border-radius: 5px;
  border-radius: 5px;
}
.nestable-drag-layer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  pointer-events: none;
}
.nestable-rtl .nestable-drag-layer {
  left: auto;
  right: 0;
}
.nestable-drag-layer > .nestable-list {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0;
  background-color: rgba(106, 127, 233, 0.274);
}
.nestable-rtl .nestable-drag-layer > .nestable-list {
  padding: 0;
}
.nestable [draggable='true'] {
  cursor: move;
}
.nestable-handle {
  display: inline;
}

.component-example {
  position: relative;
  background-color: white;
  color: #49494d;
  flex: 1;
  overflow: hidden;
}
.side-by-side {
  display: flex;
}

.side-by-side .side {
  flex: 1;
  padding-left: 1em;
  padding-right: 1em;
}

.side-by-side .side + .side {
  padding-left: 3em;
  padding-right: 0;
  border-left: 1px solid #ddd;
}

.source-code-link {
  position: absolute;
  top: 0;
  right: 0;

  width: 1.3em;
  height: 1.3em;

  padding: 0.3em;
  background-color: #5b6fd61e;
  border-left: 1px solid #5b6fd657;
  border-bottom: 1px solid #5b6fd657;
  color: #5b6fd6a1;
  border-bottom-left-radius: 4px;

  opacity: 0;
  transition: opacity 0.1s ease-in-out;
}

.component-example:hover .source-code-link {
  opacity: 1;
}

.nestable-list-empty {
  text-align: center;
}

.nestable-item-content {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
}

.nested-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>
